var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingStarterQuiz3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 218,
    height: 210,
    viewBox: "0 0 218 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab9sxw3tca",
    x1: "0%",
    x2: "99.998%",
    y1: "49.991%",
    y2: "49.991%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#020203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f9p3c3bozb",
    x1: ".004%",
    x2: "100.01%",
    y1: "49.993%",
    y2: "49.993%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#020203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hnkjat8otc",
    x1: "-.001%",
    x2: "99.997%",
    y1: "49.998%",
    y2: "49.998%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#020203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kbmocfp5ud",
    x1: "-.009%",
    x2: "99.993%",
    y1: "49.995%",
    y2: "49.995%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#020203"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-780 -34) translate(780 34)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.583,
    cy: 196.193,
    fill: "#DEE0E9",
    rx: 101.524,
    ry: 13.537
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DA142",
    d: "M97.167 9.98C89.487 3.86 79.694.6 68.685.348l-.003-.004h-.212c-.816-.015-1.636-.018-2.463 0H49.021L55.478 1.4c-1.255.223-2.52.476-3.798.765-13.547 3.095-23.736 11.799-29.469 25.17-3.97 9.257-4.35 17.61-4.38 18.531-.09 2.813.842 5.422 2.463 7.467-1.91 1.625-9.124 4.336-9.124 4.336s12.186.793 18.095.007c6.084-.809 11.213-4.873 11.418-11.053.007-.186.794-18.673 16.097-22.17 10.961-2.506 20.243-1.295 26.14 3.406 4.863 3.878 7.329 10.064 7.332 18.388 0 9.698-11.985 18.834-22.558 26.893C57.57 80.854 48.83 87.516 46.478 97.057c-3.82 15.498-3.051 32.971-3.018 33.706.099 2.1.757 4.036 1.825 5.678-.98 1.35-7.57 3.066-8.125 5.2l17.71.01c.18 0 .36-.003.535-.01 6.304-.29 11.177-5.639 10.891-11.942-.007-.125-.46-10.833 1.248-21.534.655-4.098 2.788-7.811 5.956-10.493 2.554-2.162 5.62-4.496 8.049-6.348 13.32-10.152 31.57-24.054 31.566-45.08-.008-15.194-5.671-28.072-15.948-36.264zM47.093 146.085c-2.302-.428-7.083-.867-11.353.421l.549 28.346s7.62.696 11.923.107c.395-.055.794-.1 1.193-.118 6.062-.285 10.888-5.286 10.888-11.418v-5.495c0-5.802-4.325-10.599-9.93-11.334-1.093-.146-2.184-.304-3.27-.509z",
    transform: "translate(103.17)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7FBC4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.152 141.648c-6.065 0-11.122-4.768-11.407-10.888-.033-.736-.805-18.209 3.018-33.706 2.353-9.542 11.093-16.204 21.216-23.916 10.573-8.06 22.562-17.192 22.559-26.894 0-8.327-2.466-14.514-7.332-18.388-5.897-4.701-15.18-5.908-26.14-3.406-15.3 3.498-16.09 21.984-16.098 22.17-.205 6.18-5.279 11.053-11.418 11.053-.128 0-.256-.003-.384-.007C4.855 57.457-.088 52.17.12 45.863c.029-.922.413-9.274 4.379-18.53C10.233 13.965 20.422 5.26 33.97 2.163 51.852-1.925 68.005.848 79.452 9.976 89.73 18.168 95.392 31.05 95.396 46.24 95.4 67.266 77.155 81.168 63.83 91.32c-2.429 1.852-5.495 4.186-8.048 6.348-3.169 2.682-5.302 6.395-5.956 10.493-1.709 10.705-1.255 21.41-1.248 21.534.285 6.304-4.591 11.649-10.891 11.942-.18.007-.359.01-.535.01zM36.289 174.852c-6.315 0-11.43-5.118-11.43-11.429v-5.495c0-6.315 5.119-11.43 11.43-11.43 6.315 0 11.43 5.12 11.43 11.43v5.495c.003 6.311-5.115 11.43-11.43 11.43z",
    transform: "translate(103.17)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab9sxw3tca)",
    d: "M10.013 19.965S19.511 3.538 45.596 1.123C71.678-1.29 81.022 15.45 81.022 15.45S58.13 5.48 39.523 10.427c-18.607 4.946-24.216 16.39-27.252 15.691-3.037-.706-5.034-2.517-2.258-6.153z",
    transform: "translate(103.17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f9p3c3bozb)",
    d: "M4.562 31.566S.344 41.646 2.071 48.15c1.727 6.505 7.397 9.11 11.056 7.632 3.658-1.482-8.565-24.216-8.565-24.216z",
    transform: "translate(103.17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hnkjat8otc)",
    d: "M31.423 130.215c-.33 1.642-2.641 1.745-3.113.139-.322-1.105-.542-2.345-.505-3.644.117-4.438 1.054-29.48 4.32-34.687 6.89-10.98 37.607-32.674 39.36-35.839 1.752-3.168 7.825-9.241 6.19-1.65-1.636 7.592-19.504 24.527-24.06 28.145-4.554 3.622-13.43 5.84-17.747 25.99-1.646 7.68-3.406 16.35-4.445 21.546z",
    transform: "translate(103.17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kbmocfp5ud)",
    d: "M33.761 147.691s-5.294 1.559-6.93 5.997c-1.635 4.438-2.022 13.588 1.208 16.196 3.23 2.605 14.404-23.634 5.722-22.193z",
    transform: "translate(103.17)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#55235C",
    d: "M22.833 21.015S6.106 34.438.966 53.363C-4.174 72.29 21.52 82.998 26.66 81.753c5.14-1.243 4.43-6.38 1.317-8.608-3.114-2.228-13.895-11.656-14.162-15.673-.344-5.14 13.456-16.873 13.456-16.873l-4.438-19.584z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001437",
    d: "M41.82 153.139s.736 4.152.689 5.009c-.048.856-4.116.684-4.285 2.612-.172 1.928 5.909 2.656 8.909.944 2.996-1.713 3.212-7.409 3.424-9.977.216-2.568-2.784-2.397-5.436-2.74-2.66-.344-4.288 2.656-3.3 4.152z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F8",
    d: "M15.87 114.344c-3.75-.37-4.96-3.12-5.209-5.872C13.116 95.737 27.86 78.713 27.86 78.713s20.488-4.7 19.653 3.044c-1.58 14.693-18.31 22.738-20.246 27.878-.073.19-.102.395-.102.615-1.625 1.613-5.517 4.665-11.294 4.094z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001437",
    d: "M15.878 107.952c-.995-1.547-.808-2.82-.168-4.492l-6.099-.542s-.67 2.543-1.8 3.703c-2.202 2.26-7.383 3.98-7.504 4.792-.205 1.358 12.86 1.983 15.227.721 1.244-.658 1.434-2.484.344-4.182z",
    transform: "translate(76.463 39.512) translate(6.585 52.317)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M54.362.549c.008.355.03.713.07 1.072.325 3.131.848 13.686 1.533 17.996C57.64 30.154 50.433 50.7 49.95 52.16c-4.705 14.272-21.966 43.364-28.09 54.413-1.365 2.462-14.36.216-14.001-2.041 2.828-17.938 29.348-76.058 28.847-78.092L38.001.241c4.778.633 10.544.974 16.361.308z",
    transform: "translate(76.463 39.512) translate(6.585 52.317)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F8",
    d: "M36.706 26.444l.64-12.977c3.85-.347 6.74-.465 6.74-.465s-1.475 14.214-5.104 25.724c-3.63 11.51-3.169 21.914-11.623 34.891-8.452 12.973-11.152 20.649-12.564 25.548-.585 2.03-1.46 5.026-2.28 7.836-2.659-.596-4.803-1.529-4.656-2.466 2.824-17.941 29.348-76.06 28.847-78.091z",
    transform: "translate(76.463 39.512) translate(6.585 52.317)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#82368C",
    d: "M67.259 75.077c.552-37.35-6.871-46.917-9.615-52.504-3.545-7.214-7.324-14.202-25.28-7.412-5.616 2.122-14.254 7.796-12.879 13.639.85 3.611 6.286 30.604 6.286 30.604s1.441 14.389.984 17.363c-1.035 6.75 10.072 8.718 18.746 5.89 3.337-1.086 8.88-8.502 12.161-8.798 5.276-.483 9.582 2.052 9.597 1.218z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B112E",
    d: "M39.212 15.49s-.786 2.975-.82 3.714c-.032.739-.065 2.023-1.379 1.668-1.317-.355-2.535-.9-3.179-.9-.644 0-2.32 1.072-2.956 1.043-.637-.03-1.262-.6-.34-3.088.918-2.484.31-.432 2.43-.366 2.117.066 4.206-.384 4.4-.9.19-.512 1.844-1.17 1.844-1.17z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B112E",
    d: "M32.206 19.452c.216-1.412 3.842-1.591 3.911-.676 0 0-.227 1.964-1.127 2.22l-.047.011c1.174 4.464 5.996 22.917 6.278 26.583.322 4.175-1.222 7.453-2.312 7.321-1.09-.128-2.69-4.749-2.792-6.838-.091-1.91-2.162-23.378-2.52-27.091-.79-.19-1.523-.67-1.39-1.53z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#211B40",
    d: "M10.913 8.982c0-.004.004-.004 0 0 .293-.63-.175-2.623-1.097-4.354-.922-1.73-2.386-.926-2.386-.926s.3-1.32-.343-1.928c-.64-.61-1.983.55-1.983.55S5.18.358 3.424.336C1.551.31.593 2.144.417 2.876-.827 8.056 2.674 8.97 2.674 8.97c1.248 2.517 8.316 1.573 8.316 1.573s.117-.618-.077-1.562z",
    transform: "translate(76.463 39.512) translate(24.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M9.435 8.305l4.778 6.86c.319 1.068-4.115 4.595-6.197 3.731-.611-.252-1.233-.208-1.09-1.456l1.017-6.856 1.492-2.28z",
    transform: "translate(76.463 39.512) translate(24.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M7.178 6.238l2.854 3.658c.845 1.28.52 3-.736 3.882-1.006.702-1.723.962-3.212 1.302-1.236.286-2.257-.636-2.817-2.191-.728-2.016-.823-4.083-.812-5.188.025-2.52 2.689-3.713 4.723-1.463z",
    transform: "translate(76.463 39.512) translate(24.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211B40",
    d: "M10.035 9.896L7.182 6.238c-.25-.275-.509-.498-.769-.673.363.808 1.017 2.6.9 2.985-.3.984-.512.256-1.92.717-.897.293-1.969 1.142-2.634 1.723.12.619.281 1.262.512 1.903.56 1.555 1.58 2.473 2.817 2.191 1.485-.34 2.206-.604 3.212-1.302 1.255-.882 1.577-2.605.735-3.886z",
    transform: "translate(76.463 39.512) translate(24.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.465 11.868s.834-.677 2.246-1.138c0 0-2.041-.23-2.246 1.138z",
    transform: "translate(76.463 39.512) translate(24.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M7.672 7.957c-.037-.285-.12-.56-.216-.83-.186-.516-.34-1.32.556-1.222 1.306.146 2.22 2.641 1.025 3.307-.886.494-1.27-.538-1.365-1.255z",
    transform: "translate(76.463 39.512) translate(24.512)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M33.991 16.76s-1.964-1.99-2.575-1.358c-.607.633-1.683 5.609-.403 5.261 1.285-.35 2.69-1.372 2.69-1.372s4.156 1.098 4.16.18c.003-.919 1.828-3.871 1.477-4.976s-1.478-2.038-2.166-1.855c-1.258.333-3.183 4.12-3.183 4.12z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B112E",
    d: "M45.589 22.02l15.216 6.78c.841 1.873 1.727 4.145 2.56 6.984.294.995-5.55-2.13-9.94-5.71-4.635-3.78-7.836-8.053-7.836-8.053z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82368C",
    d: "M44.495 15.402c1.434-7.1 31.17.253 38.517 22.716C89.01 56.448 70.895 78.22 62.03 77.641c-8.864-.578 10.808-27.124 8.05-36.61-2.298-7.918-19.179-14.024-24.495-19.014-1.81-1.701-1.408-5.038-1.09-6.615z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.661 108.472c.52-2.737 5.188-7.917 16.507 1.774.011 5.645 17.803 28.786 20.861 35.338 1.822 3.904-2.7 7.625-6.168 9.037-3.468 1.412-30.062-28.672-31.474-41.39-.165-1.481-.052-3.083.274-4.759z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B112E",
    d: "M24.72 42.885c-1.843 1.705-4.375 4.167-6.537 6.688-.168-7.43 1.43-20.213 1.43-20.213l5.108 13.525z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F8",
    d: "M10.661 108.472c.234-1.233 1.313-2.963 3.465-3.604-.535 2.192-1.413 7.058.314 10.42 2.29 4.452 4.003 3.234 5.543 7.313 1.54 4.08 4.968 9.816 7.793 13.84 2.828 4.025 11.048 10.277 12.76 12.161 1.464 1.61 3.86 3.154 4.424 4.266-1.003.743-2.093 1.347-3.095 1.756-3.469 1.413-30.063-28.672-31.475-41.389-.168-1.485-.055-3.087.271-4.763z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55235C",
    d: "M30.359 16.01c-.868 4.375-2.247 12.614-1.643 18.168.856 7.88 4.105 19.185 5.393 29.89 1.093 9.095 3.497 14.726.804 19.683-4.997-.592-8.776-2.923-8.154-6.988.453-2.97-.985-17.363-.985-17.363s-5.436-26.996-6.285-30.604c-1.226-5.18 5.43-10.229 10.87-12.786z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M25.533 72.765s.516-1.925 1.222-2.583c.702-.659 4.694-1.222 4.785-.377.095.845-2.488.794-3.003 1.266 0 0 2.956.003 3.424.845.468.845-.702 1.69-1.924 2.158-1.222.469-1.643.703-1.643.703s2.865-.468 3.143-.703c.278-.234 1.174.421-.33 1.409-1.5.984-4.394 3.004-5.012 2.605-.618-.395-1.123-4.006-.662-5.323z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55235C",
    d: "M45.589 22.02c-1.017-.954-1.339-2.425-1.365-3.808 1.014.995 2.675 1.994 5.35 2.806 8.798 2.675 10.276.362 18.756 7.75 8.481 7.386 15.096 11.56 9.121 20.297-5.974 8.736-10.149 8.798-11.433 15.867-1.262 6.936-1.781 10.55-4.624 12.614-7.19-1.876 11.374-27.27 8.693-36.508-2.305-7.925-19.182-14.03-24.498-19.017z",
    transform: "translate(76.463 39.512)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M60.062 74.433s-3.307 1.405-4.24 1.584c-.933.18-2.268.3-2.268 1.028s1.284.6 2.1.428c.812-.172 1.156.428 1.156.428l4.28 3.853s4.069-3.769 3.04-5.397c-1.028-1.624-4.068-1.924-4.068-1.924z",
    transform: "translate(76.463 39.512)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingStarterQuiz3);
export default __webpack_public_path__ + "static/media/landing-starter-quiz-3.1d41c8535ef84be2ec4fe8e31922ccf1.svg";
export { ForwardRef as ReactComponent };